import React, { Component } from 'react';
import { Row, Col, Navbar, Nav, Button, Form, Modal } from 'react-bootstrap';
import moment from 'moment';

import Auth from '../../Auth/Auth';

const auth = new Auth();

function convertToLocal(date){
    var stillUtc = moment.utc(date).toDate();
    var local = moment(stillUtc).local().format('YYYY-MM-DD HH:mm:ss');
    return local;
}

function xml2json(xml){
    // Create the return object
    var obj = {};
  
    if (xml.nodeType === 1) {
      // element
      // do attributes
      if (xml.attributes.length > 0) {
        obj["@attributes"] = {};
        for (var j = 0; j < xml.attributes.length; j++) {
          var attribute = xml.attributes.item(j);
          obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
        }
      }
    } else if (xml.nodeType === 3) {
      // text
      obj = xml.nodeValue;
    }
  
    // do children
    // If all text nodes inside, get concatenated text from them.
    var textNodes = [].slice.call(xml.childNodes).filter(function(node) {
      return node.nodeType === 3;
    });
    if (xml.hasChildNodes() && xml.childNodes.length === textNodes.length) {
      obj = [].slice.call(xml.childNodes).reduce(function(text, node) {
        return text + node.nodeValue;
      }, "");
    } else if (xml.hasChildNodes()) {
      for (var i = 0; i < xml.childNodes.length; i++) {
        var item = xml.childNodes.item(i);
        var nodeName = item.nodeName.replace(':','');
        if (typeof obj[nodeName] === "undefined") {
          obj[nodeName] = xml2json(item);
        } else {
          if (typeof obj[nodeName].push === "undefined") {
            var old = obj[nodeName];
            obj[nodeName] = [];
            obj[nodeName].push(old);
          }
          obj[nodeName].push(xml2json(item));
        }
      }
    }
    return obj;
}

export default class SearchCrawlHealth extends Component {
    constructor(props){
        super(props);

        this.state = {
            Health : [],
        };
    }

    componentDidMount(){
        let self = this;
        fetch(`https://fetch.ceridian.com/texis/search/main.xml?dropXSL=no&pr=Health&query=TFS+OR+D365+OR+Confluence+OR+KB+OR+AhaIdeas+OR+Community`)
        .then(success => success.text())
        .then(str => str)
        .then(data => {  
          let escapedData = data.replaceAll(new RegExp('<b>', 'g'), "//b").replaceAll(new RegExp('</b>', 'g'), "//#b");
          let backToXml = (new window.DOMParser()).parseFromString(escapedData, "text/xml");
          var json = xml2json(backToXml);
          this.setState({
              Health : json.ThunderstoneResults.Result
          });
        });
    }

    render () {      
        return (
            <div>
                <Row className="search-health">
                    <Col lg={{span : 12}} className="mt-3">
                        <span>Last Thunderstone update</span>
                    </Col>                    
                    {this.state.Health.map((items,index) =>
                    <Col lg={{span : 3}} key={index}>
                        <div className="kpi-box pt-3">
                            <h4>{items.ResultTitle.replaceAll("//b","").replaceAll("//#b","")}</h4>
                            <span>{convertToLocal(`${items.Abstract.replaceAll(`Source ModifiedDate ${items.ResultTitle}`,"").replaceAll("//#b","").replaceAll(" GMT-0500","")}`)}</span>
                        </div>
                    </Col>
                    )}
                </Row>
               </div>
        );
    }
}